import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import React, { type FC } from 'react';

import { useFooter, useTranslations } from '../../hooks';
import { SocialMediaIcon } from './components';
import { FOLLOW_US } from './constants';
import { FollowUsRoot, Icons } from './styles';

export const FollowUs: FC = () => {
  const { getTestId } = useTestId();
  const { translations } = useTranslations();
  const { socialMediaLinks } = useFooter();

  return (
    <FollowUsRoot data-testid={getTestId(FOLLOW_US)}>
      <Typography
        component="h5"
        variant="h5"
      >
        {translations.followUs}
      </Typography>
      <Icons>
        {socialMediaLinks.map(({ type, title, url }, index) => (
          <SocialMediaIcon
            key={title ?? index}
            type={type}
            title={title}
            url={url}
          />
        ))}
      </Icons>
    </FollowUsRoot>
  );
};
